import { createFileRoute } from '@tanstack/react-router';

import { CaseSearchResultsPage } from '@/features/cases/CaseSearchResultsPage';
import { caseSearchParamsSchema } from '@/features/cases/utils/caseSearchSchema';

export const Route = createFileRoute('/cases/search')({
	validateSearch: caseSearchParamsSchema,
	component: RouteComponent,
});

function RouteComponent() {
	const criteria = Route.useSearch();
	return <CaseSearchResultsPage criteria={criteria} />;
}
